module.exports = __webpack_public_path__ + "static/media/garantia-de-devolucion-del-dinero.e1f3f8c4.png";